<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Houten ramen</h1>

      <p>
        Houten ramen worden voornamelijk vervaardigd uit hardhout of naaldhout.
        Ze geven de woning meer karakter, beschikken over een meer authentieke
        uitstraling en geven het geheel meer warmte mee.
      </p>

      <p>
        Belangrijk bij de keuze van houten ramen is de houtsoort. Houten ramen
        kunnen worden gemaakt uit verschillende houtsoorten. Hierbij kunnen we
        denken aan afzelia, meranti, douglas, lorken, grenen, vuren en merbau
        waarbij meranti een erg populaire houtsoort is. Zo bestaan er een
        honderdtal soorten meranti. Enkele daarvan zijn slechts geschikt voor
        het fabriceren van ramen. Hierbij kunnen we denken aan de “Dark red
        meranti”.
      </p>

      <p>
        Verder beschikken houten ramen uit “afzelia” of “merbau” over een hogere
        duurzaamheidsklasse dan bijvoorbeeld “vuren” of “grenen”. Hierdoor
        hoeven houten ramen uit merbau of afzelia niet te worden geschilderd om
        te levensduur te verlengen.
      </p>

      <p>
        Het is dus raadzaam om bij de keuze van het houtsoort het FSC-keurmerk,
        het keurhout logo of het KOMO kenmerk na te gaan.
      </p>

      <p>
        Hedendaagse houten ramen worden zodanig gefabriceerd zodat zij bestemd
        zijn tegen erg wisselende weersomstandigheden. Hierdoor kan het
        onderhoud van houten ramen tot een minimum beperkt worden.
      </p>

      <h2>Waarom kiezen voor houten ramen?</h2>

      <ul>
        <li>Geeft een authentieke uitstraling mee</li>
        <li>Goed in onderhoud</li>
        <li>Relatief voordelig in aanschaf t.o.v. aluminium en PVC</li>
        <li>Lange levensduur</li>
        <li>
          Komen het best tot hun recht in moderne of hedendaagse woningen.
        </li>
      </ul>

      <p>
        Het enige nadeel van houten ramen is de relatief lagere isolatiewaarde.
        Wanneer isolatiewaarde een prioriteit is bij de aanschaf van nieuwe
        ramen kan worden overwogen om voor PVC ramen te installeren.
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Houten ramen: de voor- en nadelen van hout!',
      headDescription:
        'Bent u van plan om houten ramen aan te schaffen? Op Ramenvergelijker.be leest u alles over houten ramen en vergelijkt u gratis offertes!',
      path: '/informatie-over-ramen/hout',
    }
  },
}
</script>
